
import React, { useState, useEffect } from 'react';
import { ProfileProgressStepsList } from 'constants/progress-steps-constants';
import OnboardingProgressSteps from 'components/onboarding-progress-steps';
import styled from 'styled-components';
import { SuccessButton } from 'components/button';
import { useMediaQuery } from 'react-responsive';
import '../../../font-icon.css';
import CartSummary from 'components/cart-summary/index';
import { CommonStyledComponentProps } from '__utils/type';
import riskMobile from 'images/risk-mobile.svg';
import RiskSurvey from './risk-survey';
import { isFlowTypeCheckout, getQueryParamsFromString, isFlowTypeProfile, isBtoCFlow } from '__utils/common-utils';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import CartSelector from 'views/cart/cart.selector';
import { getAgentCode, getUserDetails } from '__utils/storage';
import Footer from 'components/footer';
import MobileFooterLayout from 'components/old-footer-layout';
import { LayoutContext } from 'components/app-routes';
import { CommonTitleDiv } from 'views/common-styled-components';


const RiskProfileWhiteCard = styled.div<CommonStyledComponentProps>`
    padding: ${(props: any) => !props.isMobile ? "0 0 16px 24px" : "16px"};
    margin-bottom: 30px;
    height: auto;
    overflow: auto;
    .inner-cont {
        padding: 24px 0 0 0;
        display: flex;
    }
    .cartWidth{
        width: ${(props: any) => !props.isMobile ? "447px" : "auto"};
    }
    .spWidth{
        width: ${(props: any) => !props.isMobile ? "350px" : "auto"};
    }
    .profileWdth{
        width: ${(props: any) => !props.isMobile ? "350px" : "auto"}; 
    }
`;
const DesktopSubmitButton = styled(SuccessButton)`
        margin-top: -100px; 
        width: 200px;
        font-size: 14px; 
`;


const RiskProfile: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [ stage, setStage ] = useState<'risk-profile' | 'risk-survey'>('risk-profile');
    const { completed, previous } = getQueryParamsFromString(window.location.search);
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        Mixpanel.track(getEventName("riskProfileInfo", "loaded", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        if (completed || previous) setStage('risk-survey');
        isFlowTypeCheckout() && SetLayoutProps({
            config: { title: 'Investor Profile' }
        })
    }, []);

    const returnComponent = () => {
        return (<div>
            <div className={ (!isMobile && isFlowTypeCheckout()) ? 'cardCont' : '' }>
                <RiskProfileWhiteCard isMobile={ isMobile }>
                    { (!isMobile && isFlowTypeCheckout()) && <CartSummary /> }
                    { !isMobile && (isFlowTypeCheckout() && <CommonTitleDiv>Investor Profile</CommonTitleDiv>) }
                    { isFlowTypeCheckout() && <OnboardingProgressSteps
                        stepsList={ ProfileProgressStepsList }
                        currentStep={ 2 }
                    /> }
                    <div className={ isMobile ? (isFlowTypeProfile() ? "risk-white-card mb-120" : "risk-white-card mb-60") : "inner-cont" } >
                        { stage === "risk-profile" &&
                            <div /* className="mb-60"  */>
                                <div className={ isMobile ? "flexCol" : (isFlowTypeCheckout() ? ((cartDetails && cartDetails?.noOfItems > 0) ? "reverseFlex" : "rev-flex-without-cart") : "reverseFlex-profile") }>
                                    <div className={ isMobile ? "text-center" : "" } style={ { width: isMobile ? "auto" : (isFlowTypeCheckout() ? ((cartDetails && cartDetails?.noOfItems > 0) ? "300px" : "380px") : "330px") } }>
                                        <object data={ riskMobile } style={ { marginTop: isFlowTypeProfile() ? "50px" : "0px" } }></object>
                                    </div>
                                    <div className={ isFlowTypeCheckout() ? ((cartDetails && cartDetails?.noOfItems > 0) ? "spWidth" : "cartWidth") : "profileWdth" }>
                                        { (isFlowTypeProfile() || (isFlowTypeCheckout() && isMobile)) && <p style={ { fontSize: "24px", lineHeight: "1.5", marginTop: "20px" } }>Risk Profiling</p> }<br />
                                        <p style={ { textAlign: "justify" } }>A risk profile is an evaluation of your willingness and ability to take risks.<br /><br />
                                            Risk Profiling is important for proper investment asset allocation and determining what proportion of your portfolio should be invested in which asset class.</p><br/><br/>
                                    </div>
                                </div><br />
                                { isMobile ?
                                    <div className="sticky-footer" style={ { bottom: isFlowTypeProfile() ? "60px" : "0" } }>
                                        <SuccessButton onClick={ () => setStage('risk-survey') }>Let's Begin</SuccessButton>
                                        { isFlowTypeProfile() && <Footer>
                                            <MobileFooterLayout />
                                        </Footer> }
                                    </div> :
                                    <DesktopSubmitButton onClick={() => setStage('risk-survey')}>Let's Begin</DesktopSubmitButton>
                                }
                            </div>
                        }
                        { stage === "risk-survey" && <RiskSurvey /> }
                    </div>
                    { (!isFlowTypeCheckout() && !isMobile) &&
                        <p className="queryText">If you need any help or have any query just write to us at <a href="mailto:help@turtlemintmoney.com">help@turtlemintmoney.com</a> or call us at: <a href="tel:18002666468">18002666468</a>.</p> }

                </RiskProfileWhiteCard>
            </div>
        </div>)
    }

    return (
        <div>
            { returnComponent() }
        </div>);
};

export default RiskProfile;

